import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

const initialState: {
  userData: any;
  userLoading: boolean;
  userError: SerializedError | null;
} = {
  userData: {},
  userLoading: false,
  userError: null,
};

export const userFunc = createAsyncThunk(
  'user/userFunc',
  async (values: { userId: string | null }) => {
    const accessTokenJSON = localStorage.getItem('auth');

    const data1 = JSON.stringify({
      query: `query User($userId: ID) {
        user(userId: $userId) {
            personalInformation {
            childAge
            name
            surname
            phoneNumber
            profileImageUrl
            organization
            }
            role
            contact {
            address {
                city
                district
            }
            phoneNumber
            }
            socialMedia {
              facebook
              instagram
              twitter
              website
              youtube
            }
            onboarded
            createdAt
            _id
        }
    }`,
      variables: {
        userId: values?.userId ?? null,
      },
    });

    const config = initialConfig(
      process.env.REACT_APP_BASE_URL_USER || '',
      data1,
      accessTokenJSON ? JSON.parse(accessTokenJSON).accessToken : ''
    );

    const response = axios(config)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((err) => err);

    const data = await response;
    return data;
  }
);

const user = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(userFunc.pending, (state) => {
      state.userLoading = true;
    });
    builder.addCase(userFunc.fulfilled, (state, action) => {
      state.userLoading = false;
      state.userData = action.payload?.data?.user;
      state.userError = action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(userFunc.rejected, (state, action) => {
      state.userLoading = false;
      state.userError = action.error;
    });
  },
});

export default user.reducer;
